<template>
  <div class="service detail wrap">
    <div class="text-bg monitoring">
      <div class="text-wrap">
        <p>{{ $t('consulting.detail.monitoring.lineText.01') }}</p>
        <p>{{ $t('consulting.detail.monitoring.lineText.02') }}</p>
        <p>{{ $t('consulting.detail.monitoring.lineText.03') }}</p>
      </div>
    </div>
    <HalfPageLayout class="monitoring title">
      <template #half-left>
        <div class="img monitoring"></div>
      </template>
      <template #half-right>
        <div class="inner-contents">
          <div class="contents-title">
            <h3 style="line-height: 1.1">
              {{ $t('consulting.title.monitoring') }}
            </h3>
            <h6>Monitoring &amp; Security</h6>
            <h4>{{ $t('consulting.detail.monitoring.subTitle') }}</h4>
          </div>
          <h5>{{ $t('consulting.detail.monitoring.desc') }}</h5>
        </div>
      </template>
    </HalfPageLayout>
    <HalfPageLayout class="monitoring summary bg-light">
      <template #half-left>
        <div class="inner-contents">
          <div class="section-title" data-aos="fade">
            <h3 class="hl">{{ $t('consulting.detail.monitoring.firstPage.title') }}</h3>
          </div>
          <div class="section-contents">
            <div class="contents-list icon" data-aos="fade" data-aos-delay="500">
              <Icon icon="ph:pulse-thin"></Icon>
              <dl>
                <dt>{{ $t('consulting.detail.monitoring.firstPage.contents.01.title') }}</dt>
                <dd>{{ $t('consulting.detail.monitoring.firstPage.contents.01.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1000">
              <Icon icon="ph:wifi-high-thin"></Icon>
              <dl>
                <dt>{{ $t('consulting.detail.monitoring.firstPage.contents.02.title') }}</dt>
                <dd>{{ $t('consulting.detail.monitoring.firstPage.contents.02.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1500">
              <Icon icon="ph:file-text-thin"></Icon>
              <dl>
                <dt>{{ $t('consulting.detail.monitoring.firstPage.contents.03.title') }}</dt>
                <dd>{{ $t('consulting.detail.monitoring.firstPage.contents.03.desc') }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
      <template #half-right>
        <div class="img visual-01"></div>
      </template>
    </HalfPageLayout>
    <HalfPageLayout class="monitoring summary">
      <template #half-left>
        <div class="img visual-02"></div>
      </template>
      <template #half-right>
        <div class="animation-bg">
          <div class="gear"><SvgGear /></div>
          <div class="gear"><SvgGear /></div>
        </div>
        <div class="inner-contents">
          <div class="section-title" data-aos="fade">
            <h3 class="hl">{{ $t('consulting.detail.monitoring.secondPage.title') }}</h3>
          </div>
          <div class="section-contents">
            <div class="contents-list icon" data-aos="fade" data-aos-delay="500">
              <Icon icon="ph:bug-thin"></Icon>
              <dl>
                <dt>{{ $t('consulting.detail.monitoring.secondPage.contents.01.title') }}</dt>
                <dd>{{ $t('consulting.detail.monitoring.secondPage.contents.01.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1000">
              <Icon icon="ph:shield-warning-thin"></Icon>
              <dl>
                <dt>{{ $t('consulting.detail.monitoring.secondPage.contents.02.title') }}</dt>
                <dd>{{ $t('consulting.detail.monitoring.secondPage.contents.02.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1500">
              <Icon icon="ph:lock-key-thin"></Icon>
              <dl>
                <dt>{{ $t('consulting.detail.monitoring.secondPage.contents.03.title') }}</dt>
                <dd>{{ $t('consulting.detail.monitoring.secondPage.contents.03.desc') }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
    </HalfPageLayout>
    <section class="section monitoring benefit">
      <h2 class="hl section-title">{{ $t('consulting.detail.monitoring.benefit.title') }}</h2>
      <div class="section-contents">
        <div class="benefit-grid inner-contents">
          <div
            v-for="(item, key) in $tm('consulting.detail.monitoring.benefit.contents')"
            :key="key"
            class="benefit-card"
            data-aos="fade-up"
          >
            <dt>{{ item.title }}</dt>
            <dd>{{ item.desc }}</dd>
          </div>
        </div>
        <router-link to="/contact" class="button big line">
          {{ $t('service.detail.contact') }}
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import HalfPageLayout from '@/components/HalfPageLayout'
import { Icon } from '@iconify/vue'
import SvgGear from '@/components/SvgGear'

export default {
  name: 'ConsultingDetailMonitoring',
  components: { SvgGear, HalfPageLayout, Icon }
}
</script>

<style scoped>
</style>
